import React from 'react';
import ErrorMessage from './ErrorMessage';

interface TextInputProps {
    label?: string;
    defaultValue?: string;
    value: string;
    placeholder?: string;
    className?: string;
    inputId?: string;
    inputClassName?: string;
    labelId?: string;
    labelClassName?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
    disabled?: boolean;
}

const TextInput = (props: TextInputProps) => {
    const { label, defaultValue, value, placeholder, onChange, ...rest } = props;

    return (
        <div className={`base-text-input ${rest.className || ''} `}>
            {label && (
                <label
                    id={rest.labelId}
                    className={`text-input-label ${rest.labelClassName || ''}`}
                >
                    {label}
                </label>
            )}
            <input
                id={rest.inputId}
                className={`text-input ${rest.inputClassName || ''}`}
                type="text"
                placeholder={placeholder || ''}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
                disabled={rest.disabled}
            />
            {rest?.error && <ErrorMessage error={rest.error} />}
        </div>
    );
};

export default TextInput;
